<div class="flex flex-col bg-white min-w-[260px] h-full" [ngClass]="{'lg:gap-6 lg:flex-row': fullWidth}">
    <div class="min-w-[260px] h-[200px] shrink-0 bg-center bg-cover relative" [ngClass]="{'lg:h-auto lg:basis-auto': fullWidth}" [style.background-image]="'url(' + formation.imageLink + ')'" >
        <div *ngIf="formation.isNew" class="m-2 px-1 absolute typography-body-s-regular bg-border-info text-white">
            {{'new' | translate}}
        </div>
        <div class="absolute bottom-0 m-2 flex flex-wrap gap-1 items-start" [ngClass]="{'lg:hidden': fullWidth}">
            <div *ngFor="let brand of formation.brands" class="px-2 py-1 bg-background-ultralight-00">
                <img *ngIf="brand" class="textSecondary" [src]="getBrandIconSrc(brand)" [alt]="brand">
            </div>
        </div>
    </div>
    <div class="flex flex-col flex-1 gap-1 p-4" [ngClass]="{'lg:flex-1 lg:p-0': fullWidth}">
        <div class="flex flex-wrap gap-6 justify-between mb-2" [ngClass]="{'lg:mb-0': fullWidth}">
            <div class="flex flex-1 flex-wrap gap-2" [ngClass]="{'lg:flex-nowrap lg:gap-6': fullWidth}">
                <div class="flex basis-full justify-between gap-6" [ngClass]="{'lg:basis-auto lg:justify-start': fullWidth}">
                    <span class="typography-body-m-light">{{formation.publicationDate | date: 'mediumDate' }}</span>
                    <div class="flex gap-1 align-middle">
                        <img class="w-4 h-4" src="assets/icons/date.svg" alt="Date Icon">
                        <span class="typography-body-m-light">{{'minutes' | translate: {varMinutes: 20} }}</span>
                    </div>
                </div>
                <app-stars-rating [rating]="formation.rating"></app-stars-rating>
            </div>
            <div class="hidden gap-1 items-start" [ngClass]="{'lg:flex lg:flex-wrap': fullWidth}">
                <div *ngFor="let brand of formation.brands" class="px-2 py-1 bg-background-ultralight-00">
                    <img *ngIf="brand" class="textSecondary" [src]="getBrandIconSrc(brand)" [alt]="brand">
                </div>
            </div>
        </div>
        <div class="flex items-center gap-1">
            <span class="textPrimary typography-title-m">{{formation.title}}</span>
            <app-button [ghost]="true" (onClick)="toggleFavourite()">
                <img class="px-5 py-2.5" [src]="formation.isFavourite ? 'assets/icons/bookmark-filled.svg' : 'assets/icons/bookmark.svg'" alt="Favourite">
            </app-button>
        </div>
        <div class="flex-1 mb-4">
            <p class="max-3-lines lg:no-line-limit typography-body-m-light textSecondary" [ngClass]="{'lg:mb-0': fullWidth}">
                {{formation.shortDescription}}
            </p>
        </div>
        <div class="flex flex-wrap justify-between align-bottom gap-4">
            <div class="flex items-center">
                <div *ngIf="formation.completedAt" class="flex items-center gap-1">
                    <div class="rounded-full bg-semantic-success w-[10px] h-[10px]"></div>
                    <span class="typography-body-m-regular text-semantic-success">{{'cacademy.completed_on' | translate: {varDate: (formation.completedAt | date: 'mediumDate' )} }}</span>
                </div>
            </div>

            <div class="basis-full" [ngClass]="{'lg:basis-auto': fullWidth}">
                <app-button [isFullWidth]="true" [primary]="true" size="medium" (onClick)="this.goToFormation()">
                    {{
                        formation.completedAt ? ('cacademy.view_again' | translate) :
                            formation.isStarted ? ('cacademy.continue' | translate) :
                                ('cacademy.start' | translate)
                    }}
                </app-button>
            </div>
        </div>
    </div>
</div>